"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const redux_form_1 = require("redux-form");
// selectors
const contact_infos_1 = require("selectors/contact-infos");
const households_1 = require("selectors/households");
const user_1 = require("selectors/user");
// tools
const utils_1 = require("core/utils");
const view_utils_1 = require("utils/view-utils");
const bottom_buttons_1 = __importDefault(require("../bottom-buttons"));
const contact_info_fields_1 = __importDefault(require("../contact-info/contact-info-fields"));
// components
const person_photo_thumb_1 = __importDefault(require("../person-photo-thumb"));
const profile_form_fields_1 = __importDefault(require("../profile/profile-form-fields"));
// css
require("../household/household-member.scss");
class HouseholdMember extends React.Component {
    UNSAFE_componentWillMount() {
        const { history, selectedMember } = this.props;
        if (!selectedMember) {
            history.replace('/settings/household');
        }
    }
    componentWillUnmount() {
        const { showSaveNeeded, dirty, submitting, reset, handleSubmit, history, selectedMember } = this.props;
        if (dirty && selectedMember) {
            const saveNeededData = {
                message: 'You have unsaved member profile changes',
                saving: submitting,
                cancel: reset,
                onSave: handleSubmit(this.onSubmit),
                onSaveError: () => history.replace('/settings/profile'),
            };
            return showSaveNeeded(saveNeededData);
        }
    }
    onSubmit = (values) => {
        const { saveSelectedMemberProfileAndContact } = this.props;
        const profileValues = values.profile;
        const contactValues = values.contactInfos;
        return saveSelectedMemberProfileAndContact(profileValues, contactValues);
    };
    checkAge(birthdate) {
        const date = (0, utils_1.parseDate)(birthdate);
        return (0, utils_1.todayMoment)().diff(date, 'year') < 13 ? true : false;
    }
    renderEditable() {
        const { handleSubmit, submitting, reset, selectedCountry, selectedBirthday, change } = this.props;
        const isChild = this.checkAge(selectedBirthday);
        return (React.createElement("form", { id: "household-member-profile", onSubmit: handleSubmit(this.onSubmit), noValidate: true },
            React.createElement("div", { id: "profile-settings", className: "settings-section" },
                React.createElement("div", { id: "profile-info", className: "Panel" },
                    React.createElement("div", { className: "Panel-header" },
                        React.createElement("h3", { className: "Panel-title" }, "Profile Information")),
                    React.createElement("div", { className: "Panel-body" },
                        React.createElement("div", { className: "Panel-row Grid u-padNone" },
                            React.createElement("div", { className: "Panel-cell Panel-cell--header Grid-cell u-sizeFull u-xs-size8of24 u-sm-size6of24 u-textCenter u-padBottomLg u-borderBottom u-borderRightNone u-xs-borderRight u-xs-borderBottomNone" },
                                React.createElement("div", { className: "Profile-photo" },
                                    React.createElement(person_photo_thumb_1.default, null)),
                                React.createElement("h4", null, "Profile Photo"),
                                React.createElement("small", null, "Coming Soon...")),
                            React.createElement(redux_form_1.FormSection, { name: "profile" },
                                React.createElement(profile_form_fields_1.default, { change: change }))))),
                React.createElement("div", { id: "contact-info", className: "Panel" },
                    React.createElement("div", { className: "Panel-header" },
                        React.createElement("h3", { className: "Panel-title" }, "Contact Information")),
                    React.createElement("div", { className: "Panel-body Grid" },
                        React.createElement("div", { className: "Panel-cell Panel-cell--header Grid-cell u-size6of24" },
                            React.createElement("h4", null, "Primary")),
                        React.createElement("div", { className: "Panel-cell Grid-cell u-size18of24" },
                            React.createElement(redux_form_1.FormSection, { name: "contactInfos" },
                                React.createElement(contact_info_fields_1.default, { isChild: isChild, selectedCountry: selectedCountry }))))),
                React.createElement(bottom_buttons_1.default, { id: "household-member-buttons", submitting: submitting, onCancel: reset, onSubmit: handleSubmit(this.onSubmit) }))));
    }
    renderNonEditable() {
        const { selectedMember, contactInfos } = this.props;
        const person = selectedMember.person;
        const contactInfo = (0, contact_infos_1.findPrimaryByPerson)(contactInfos, person.id);
        return (React.createElement("div", { id: "profile-settings", className: "settings-section" },
            React.createElement("div", { id: "profile-info", className: "Panel" },
                React.createElement("div", { className: "Panel-header" },
                    React.createElement("h3", { className: "Panel-title" }, "Profile Information")),
                React.createElement("div", { className: "Panel-body" },
                    React.createElement("div", { className: "Panel-row Grid u-padNone" },
                        React.createElement("div", { className: "Panel-cell Panel-cell--header Grid-cell u-size6of24 u-textCenter u-padBottomLg" },
                            React.createElement("div", { className: "Profile-photo" },
                                React.createElement(person_photo_thumb_1.default, null)),
                            React.createElement("h4", null, "Profile Photo"),
                            React.createElement("small", null, "Coming Soon...")),
                        React.createElement("div", { className: "Panel-cell Grid-cell u-size18of24" },
                            React.createElement("div", { className: "profile-display" },
                                React.createElement("div", { className: "name" }, (0, view_utils_1.fullName)(person)),
                                (0, user_1.validMomentBirthdate)(person.birthdate) && (React.createElement("div", null,
                                    "Birthday: ",
                                    (0, user_1.validMomentBirthdate)(person.birthdate).format('MM/DD/YYYY'))),
                                person.gender && React.createElement("div", null,
                                    "Gender: ",
                                    (0, lodash_1.capitalize)(person.gender))))))),
            contactInfo && (React.createElement("div", { id: "contact-info", className: "Panel" },
                React.createElement("div", { className: "Panel-header" },
                    React.createElement("h3", { className: "Panel-title" }, "Contact Information")),
                React.createElement("div", { className: "Panel-body" },
                    React.createElement("div", { className: "Panel-row Grid u-padNone" },
                        React.createElement("div", { className: "Panel-cell Panel-cell--header Grid-cell u-size6of24" },
                            React.createElement("h4", null, "Primary")),
                        React.createElement("div", { className: "Panel-cell Grid-cell u-size18of24" },
                            React.createElement("div", { className: "profile-display" },
                                React.createElement("div", null, contactInfo.emailAddress),
                                contactInfo.phoneNumber1 && (React.createElement("div", null,
                                    contactInfo.phoneNumber1,
                                    " - ",
                                    (0, lodash_1.capitalize)(contactInfo.phoneNumberLabel1))),
                                contactInfo.phoneNumber2 && (React.createElement("div", null,
                                    contactInfo.phoneNumber2,
                                    " - ",
                                    (0, lodash_1.capitalize)(contactInfo.phoneNumberLabel2))),
                                React.createElement("div", null, (0, view_utils_1.addressFull)(contactInfo))))))))));
    }
    render() {
        const { selectedMember, households } = this.props;
        if (!selectedMember)
            return null;
        const selectedMemberHousehold = selectedMember && (0, households_1.findHousehold)(households, selectedMember.householdId);
        return (React.createElement("div", { id: "households" },
            React.createElement("div", { className: "header" },
                React.createElement("div", { className: "Breadcrumbs" },
                    React.createElement("h3", { className: "Breadcrumb-item" },
                        React.createElement(react_router_dom_1.NavLink, { to: "/settings/household" },
                            selectedMemberHousehold.name,
                            " Household")),
                    React.createElement("div", { className: "Breadcrumb-item" }, (0, view_utils_1.fullName)(selectedMember.person))),
                React.createElement("div", { className: "actions" })),
            React.createElement("div", { className: "Grid" }, selectedMember.editable ? this.renderEditable() : this.renderNonEditable())));
    }
}
exports.default = (0, redux_form_1.reduxForm)({
    form: 'household-member-profile',
    enableReinitialize: true, // to load initialValues
})(HouseholdMember);
